import { render, staticRenderFns } from "./GlowBall.vue?vue&type=template&id=75d7722c&"
import script from "./GlowBall.vue?vue&type=script&lang=js&"
export * from "./GlowBall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports